const transformAll = ({ data }) => {
  const { historicalYardMovement } = data || [];
  return historicalYardMovement ? historicalYardMovement : [];
};

export { transformAll };
